import { render, staticRenderFns } from "./DisposalOrdersTableUser.vue?vue&type=template&id=28f09eb6&scoped=true"
import script from "./DisposalOrdersTableUser.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f09eb6",
  null
  
)

export default component.exports